import {
  BRAND_UPDATE_FAVOURITE_STATUS_PENDING,
  BRAND_UPDATE_FAVOURITE_STATUS_FULFILLED,
  BRAND_UPDATE_FAVOURITE_STATUS_REJECTED,
  FETCH_FAVOURITED_BRANDS,
} from '../actions/favouritedBrands';
import asyncReducer from '../helpers/asyncReducer';

const initialState = {
  favouritedBrands: {},
  busy: false,
  error: null,
  lastFetched: null,
};

const updateStateForBrand = (state, brandId, brandInfo) => {
  const brand = state.favouritedBrands[brandId] || {};
  return {
    ...state,
    favouritedBrands: {
      ...state.favouritedBrands,
      [brandId]: {
        ...brand,
        ...brandInfo,
      },
    },
  };
};

const updatingFavouriteBrands = (state, action) => {
  switch (action.type) {
    case BRAND_UPDATE_FAVOURITE_STATUS_PENDING:
      return updateStateForBrand(
        state,
        action.meta?.brandId,
        {
          busy: true,
          error: undefined,
        },
      );
    case BRAND_UPDATE_FAVOURITE_STATUS_FULFILLED:
      return updateStateForBrand(
        state,
        action.meta?.brandId,
        {
          busy: false,
          error: undefined,
          ...action.payload,
        },
      );
    case BRAND_UPDATE_FAVOURITE_STATUS_REJECTED:
      return updateStateForBrand(
        state,
        action.meta?.brandId,
        {
          busy: false,
          error: action.payload instanceof Error
            ? action.payload.message
            : 'Unexpected error',
        },
      );
    default:
      return undefined;
  }
};

const mapFulfilledFetchingToState = (state, action) => ({
  favouritedBrands: action.payload?.reduce(
    (accumulator, brandId) => ({
      ...accumulator,
      [brandId]: {
        status: true,
      },
    }),
    {},
  ),
});

const favouritedBrands = (state = initialState, action) => (
  asyncReducer(
    state,
    action,
    FETCH_FAVOURITED_BRANDS,
    mapFulfilledFetchingToState,
    {
      defaultErrorMessage: 'Unexpected error when updating favourite brand',
    },
  )
  || updatingFavouriteBrands(state, action)
  || state
);

export default favouritedBrands;
